import { render, staticRenderFns } from "./ModuleInstaller.vue?vue&type=template&id=7ae70185&scoped=true"
import script from "./ModuleInstaller.vue?vue&type=script&lang=js"
export * from "./ModuleInstaller.vue?vue&type=script&lang=js"
import style0 from "./ModuleInstaller.vue?vue&type=style&index=0&id=7ae70185&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae70185",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae70185')) {
      api.createRecord('7ae70185', component.options)
    } else {
      api.reload('7ae70185', component.options)
    }
    module.hot.accept("./ModuleInstaller.vue?vue&type=template&id=7ae70185&scoped=true", function () {
      api.rerender('7ae70185', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/modulos/otros-documentos/ModuleInstaller.vue"
export default component.exports